import { CookieService } from '../../../../../services/cookie-service';

// this cookie is set from the server when the download request is responded to
const TEMPLATE_DOWNLOADED_COOKIE_KEY = 'packing-slip-template-downloaded';

export const downloadCookieExists = () => {
  return !!CookieService.getCookieValue(TEMPLATE_DOWNLOADED_COOKIE_KEY);
};

export const removeDownloadCookie = () => {
  const isDownloaded = downloadCookieExists();
  if (isDownloaded) {
    CookieService.removeCookie(TEMPLATE_DOWNLOADED_COOKIE_KEY);
  }
};
